export default __webpack_public_path__ + "static/media/nfpa.2e298f39.svg";